export default function(source,flag) {
	console.log(flag)
	flag = flag || '';
  const { type, message, delay = 5000 } = source;
  const typeInfo = {
    success: {
      src: 'icon_pass.png',
      className: 'global_message_success'
    },
    warning: {
      src: 'icon_reject.png',
      className: 'global_message_warning'
    }
  }
  if (!typeInfo[type]) {
    console.error('不支持的类型 type');
    return;
  }
  const time = new Date().getTime()
  const str = `<div id="global_message_${time}" class="global_message ${typeInfo[type].className} ${flag}">
    <img class="global_message_icon" src="http://img.smartfacade.com.cn/mini_app/icon/${typeInfo[type].src}" alt="">
    <span class="global_message_text">${message}</span>    
  </div>`
  $('body').append(str);
  setTimeout(function() {
    $(`#global_message_${time}`).remove()
  }, delay)
}



// WEBPACK FOOTER //
// ./src/assets/js/message.js